import React, { useEffect } from 'react';
import {
  MainContainer,
  TermsText,
} from './styles';

export default function EulaDoc(props) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <MainContainer>
      {/* <GlobalStyle /> */}
      <TermsText>
        {/* <LogoWrapper src={Logo} /> */}
        <b>CONTRATO DE LICENÇA DE USUÁRIO FINAL (EULA)</b>
        <br />
        <b>Última atualização: 20 de dezembro de 2024</b>
        <br />
        <br />O presente instrumento (“CONTRATO DE LICENÇA DE USUÁRIO FINAL”),
        tem por objeto regular os termos e as condições de uso dos serviços
        oferecidos pelo Ooppah , aplicativo de propriedade da{' '}
        <b>Ooppah Solucoes Artisticas LTDA.</b>, sociedade
        limitada inscrita no CNPJ/MF sob o nº 23.825.830/0001-53 e com sede na
        Rua Afranio Melo Franco, nº 233, Bairro Quitandinha, na Cidade Petrópolis e Estado do Rio
        de Janeiro, detentora de seus direitos autorais.
        <br />
        <br />
        A aceitação deste Contrato e de todas as demais políticas e princípios
        que o regem é absolutamente indispensável a qualquer pessoa física ou
        jurídica que pretenda se tornar usuário do Ooppah .
        <br />
        <br />
        POR FAVOR, LEIA ESTE DOCUMENTO COM ATENÇÃO, POIS O USO DOS SERVIÇOS DO
        APLICATIVO Ooppah  POR VOCÊ DEMONSTRA QUE VOCÊ CONCORDA COM TODOS OS SEUS TERMOS.
        AO CLICAR EM “LI E ACEITO”, VOCÊ CONCORDA COM ESTES TERMOS E CONDIÇÕES
        DE USO DO APLICATIVO Ooppah . CASO VOCÊ TENHA QUALQUER DÚVIDA SOBRE ESSES
        INSTRUMENTOS, RECOMENDAMOS QUE ENTRE EM CONTATO COM A Ooppah  PELA SEÇÃO
        DE CONTATO DE SEU APLICATIVO.
        <br />
        <br />
        A Ooppah PODERA MODIFICAR ESTE DOCUMENTO, A QUALQUER MOMENTO, PARA
        REFLETIR EVENTUAIS ALTERAÇÕES NECESSARIAS. EVENTUAIS VERSÕES
        ATUALIZADAS SERÃO PUBLICADAS NO SITE ooppah.com, QUE DEVERA SER
        CONSULTADO REGULARMENTE.
        <br />
        <br />
        Para a sua comodidade, a data da última atualização é incluída no topo
        desta página e, posteriormente, enviaremos avisos sobre eventuais
        atualizações.
        <br />
        <br />
        Em caso de conflito entre este documento e eventual versão posterior,
        esta última prevalecerá sobre a primeira.
        <br />
        <br />
        <b>1. DEFINIÇÕES</b>
        <br />
        <br />
        Toda vez que houver menção aos termos “Sociedade”, “nós” ou “nossos”
        estaremos nos referindo à Ooppah Solucoes Artisticas LTDA.; e toda vez 
        que houver menção aos termos “Usuário”, “você”, “seu”
        ou “sua”, estaremos nos referindo à pessoa física ou jurídica que
        pretenda utilizar o aplicativo Ooppah .
        <br />
        <br />
        Ademais, para facilitar seu entendimento e evitar repetições, os termos
        constantes neste documento, sempre que usados com a primeira letra em
        maiúsculo, identificarão um termo ou expressão definida, e serão
        aplicáveis para as eventuais atualizações que este documento possa vir a
        sofrer, exceto se expressamente indicado o contrário.
        <br />
        <br />
        <b>2. UTILIZAÇÃO DO SOFTWARE</b>
        <br />
        <br />
        Para utilizar o Ooppah , o Usuário precisa:
        <br />
        <ol>
          <li data-list-text="a)">ter, pelo menos, 18 anos de idade;</li> 
          <li data-list-text="b)">A contratação dos serviços oferecidos pela 
            Ooppah é vedada a menores de 18 anos. Contudo, caso o responsável 
            legal de um menor de idade opte por contratar os serviços da Ooppah 
            e efetuar cadastro para disponibilizar um perfil para o menor de 
            idade na plataforma Ooppah, este poderá fazê-lo desde que assine 
            termo de autorização de uso de imagem, voz e dados biográficos 
            referente ao menor de idade;</li>
          <li data-list-text="c)">
            estar apto, juridicamente, a aceitar seus Termos,
          </li>
          <li data-list-text="d)">
            não ter impedimentos legais, nos termos da jurisdição aplicável;
          </li>
          <li data-list-text="e)">
            cumprir este contrato e toda a legislação pertinente, bem como a
            totalidade das normas e regulamentos aplicáveis;
          </li>
          <li data-list-text="f)">
            nunca ter sido condenado por crime grave, especialmente por assédio
            ou por qualquer outro crime que envolva violência.
            <br />
            <br />
            Se cumprir todos os requisitos acima, você poderá realizar seu
            cadastro. Para isso, você deverá enviar uma foto de perfil e
            informar seus seguintes dados: (i) nome completo; (ii) data de nascimento; (iii)
            endereço de e-mail pessoal válido (login) que seja acessado
            regularmente; (iv) endereço. Em seguida, você deverá
            criar uma senha pessoal e intransferível. Nesse sentido, você
            declara ter conhecimento de que é o único responsável por manter a
            confidencialidade e o sigilo absoluto de suas credenciais de login
            ao Ooppah , além de ser o único responsável por todas as atividades
            associadas ao uso destas credenciais. Se você acredita que alguém
            obteve acesso à sua conta, entre em contato conosco imediatamente.
            <br />
            <br />
            Para completar seu cadastro no aplicativo, o Usuário poderá
            preencher dados adicionais, como habilidades, registro profissional e seu currículo
            profissional e outros.
            <br />
            <br />
            Após finalizar seu cadastro basico, será automaticamente direcionado para local de 
            pagamento, caso tenha selecionado um plano ou para o local de completar cadastro 
            para incluir informações adicionais.
            <br />
            <br />
            Ao utilizar o Ooppah , você concorda que:
            <br />
            <br />
            <ul>
              <li data-list-text="*">
                Os cadastros realizados com endereços de e-mail inválidos
                poderão ser bloqueados ou excluídos, sem aviso prévio;
              </li>
              <li data-list-text="*">
                SUA FOTO E DADOS ARTISTICOS SERÃO DISPONIBILIZADOS PARA
                CONSULTA PÚBLICA, MAS DADOS PARA CONTATO SÓ SERAO DISPONIBILIZADOS DE ACORDO
                COM A CATEGORIA DE PESQUISADORES ASSINALADA PELO USUÁRIO EM SEU PERFIL;
              </li>
              <li data-list-text="*">
                A realização de seu cadastro corresponde à aceitação do disposto
                neste documento e de todas as demais políticas e princípios que
                o regem, podendo esta informação ser utilizada como prova de sua
                aceitação, independentemente de outra formalidade.
              </li>
              <li data-list-text="*">
                A pessoa física que deseja utilizar os serviços disponibilizados
                pelo Ooppah  deverá ser civilmente capaz, nos moldes da legislação
                civil vigente no Brasil, para que possa figurar como Usuário;
              </li>
              <li data-list-text="*">
                O Usuário poderá, a qualquer tempo, solicitar a exclusão de seu
                cadastro no Ooppah . Para tanto, deverá notificar a Sociedade pela
                seção de contato disponibilizada no aplicativo e aguardar o
                recebimento da mensagem de confirmação da exclusão. Para obter
                maiores detalhes a este respeito, favor acessar nossa Política
                de Privacidade;
              </li>
              <li data-list-text="*">
                Embora o serviço oferecido pelo Ooppah  possa ser acessado de
                forma gratuita, para que o Usuário tenha acesso a algumas
                funcionalidades especiais (“Serviços Premium”), deverá realizar
                a aquisição de um plano de acesso e realizar o respectivo
                pagamento, conforme disposto na Seção 4 deste documento. A
                liberação do acesso ao conteúdo dos "Serviços Premium" está
                condicionada à confirmação de pagamento.
              </li>
            </ul>
            <br />
          </li>
        </ol>
        <b>3. AQUISIÇÃO E CANCELAMENTO</b>
        <br />
        <br />
        Os planos Light, Premium e Vip permitem o acesso do Usuário aos Serviços
        Premium e constituem modalidades pagas de acesso. O Usuário poderá
        realizar o pagamento do Plano de Acesso escolhido por meio do
        fornecimento de dados de cartão crédito, sendo certo que a respectiva
        confirmação de pagamento poderá demorar até 3 (três) dias para ser
        reconhecida pela Sociedade, por motivos de compensação bancária de 
        acordo com a instituição financeira selecionada.
        <br />
        <br />
        A Sociedade declara que não deixa memorizados em seu aplicativo os dados
        de cartão de crédito fornecidos pelo cliente e garante que os mesmos
        serão criptografados pelo sistema de pagamento utilizado pelo Ooppah ,
        para que sejam usados unicamente no processamento de cobranças
        recorrentes.
        <br />
        <br />
        A falta de pagamento nas datas determinadas, ou do pagamento principal
        na modalidade à vista, acarretará a suspensão de acesso da conta do
        Usuário aos Serviços Premium do Ooppah , até que ocorra a regularização de
        sua pendência financeira.
        <br />
        <br />
        Os valores correspondentes aos planos de acesso poderão ser alterados a
        qualquer tempo pela Sociedade, podendo o Usuário optar por não renovar
        seu acesso, caso discorde dos novos valores propostos. Neste caso, seu
        acesso aos Serviços Premium será suspenso após encerramento do último
        período contratado.
        <br />
        <br />
        Caso o Usuário venha a desistir da aquisição de qualquer Plano de Acesso
        do Ooppah , no período de até 7 (sete) dias corridos após a data de
        confirmação da compra, terá direito à devolução de 100% (cem por cento)
        do valor pago. Após este período, não será devido o reembolso de
        qualquer valor pela Sociedade e o Usuário permanecerá com a obrigação de
        pagamento, até que haja o recebimento integral do valor correspondente a
        seu Plano de Acesso pela Sociedade.
        <br />
        <br />
        <b>4. SOBRE OS DADOS FORNECIDOS POR VOCÊ AO Ooppah </b>
        <br />
        <br />
        Ao criar uma conta, você concede ao Ooppah  uma licença universal,
        transferível, sublicenciável e isenta de royalties, além do direito de
        armazenar, hospedar, reproduzir, exibir, utilizar, copiar, adaptar,
        editar, publicar, modificar e distribuir informações que você nos
        autorizar a acessar de redes sociais terceiras, como, por exemplo, o
        Facebook ou Instagram, bem como de outras informações que você publicar,
        fizer upload, exibir ou, de outra forma, publicar no Aplicativo ou
        transmitir a outros membros.
        <br />
        <br />
        Você concorda em disponibilizar no Ooppah  apenas informações corretas,
        verdadeiras e que não violem direitos de terceiros.
        <br />
        <br />
        Você concorda e está ciente de que a Sociedade possui o direito de
        excluir ou editar qualquer conteúdo que viole ou possa a vir violar
        direitos de terceiros. A Sociedade não se responsabiliza, em hipótese
        alguma, pela autenticidade ou veracidade dos dados disponibilizados
        pelos usuários em seu Aplicativo.
        <br />
        <br />
        <b>
          5. SEGURANÇA DOS USUÁRIOS EM RELAÇÃO AO CONTATO COM PRODUTORES DE ELENCO
        </b>
        <br />
        <br />
        Você poderá ser contactado a qualquer momento por Produtores de Elenco
        que te encontraram no Ooppah. Por ser uma plataforma pública, também poderá  
        ser contactado por supostos profissionais não reconhecidos pela plataforma.
        <br />
        <br />
        Nós não nos responsabilizamos pelas condutas dos que lhe contacta. 
        Você possui responsabilidade exclusiva por suas interações com o mercado
        e está ciente de que o Aplicativo não se responsabiliza por quaisquer
        condutas, seja dentro ou fora do Aplicativo.
        <br />
        <br />
        Você reconhece que a Ooppah  também não se responsabiliza por qualquer
        resultado decorrente das interações entre artistas e contratantes. A
        função do aplicativo é apenas apresentar o artista da melhor forma ao
        mercado e você deve ter ciência que o desfecho de qualquer interação
        sofre a influência de inúmeros outros fatores sobre os quais, o Ooppah 
        não tem qualquer controle. Além disso, você não deve fornecer
        informações financeiras (como dados de pix, cartões bancários e
        informações sobre contas) e não deve transferir ou enviar dinheiro a
        ninguém. O Ooppah aconselha fortemente que os artistas certifiquem-se
	das propostas apresentadas e nunca marque encontros presenciais em locais que
	não sejam públicos, preferencialmente acompanhado(a)
        <br />
        <br />
        <b>6. PROPRIEDADE INTELECTUAL</b>
        <br />
        <br />
        O uso comercial da expressão “Ooppah ” como marca, nome empresarial ou
        nome de domínio, bem como todo conteúdo disponível no aplicativo,
        incluindo, mas não se limitando a marcas, logotipos, textos, gráficos,
        imagens, logos, telas, conteúdo editorial, notificações, software,
        bancos de dados e demais instrumentos que permitem que o Usuário acesse
        e use sua conta, são propriedades da Sociedade e estão protegidos pelas
        leis e tratados internacionais de direito autoral, marcas, patentes,
        modelos e desenhos industriais. A cópia, reprodução, distribuição,
        transmissão, publicação, conexão ou qualquer outra forma de uso indevido
        dos conteúdos mencionados acima é proibida, salvo se com autorização
        expressa da Sociedade.
        <br />
        <br />
        O Usuário declara e reconhece que a reprodução de qualquer conteúdo
        disponível pelo aplicativo do Ooppah  não lhe confere sua titularidade,
        assim como a adesão ao presente instrumento lhe atribui nenhum direito
        de propriedade intelectual ou outros direitos exclusivos da Sociedade,
        incluindo patentes, desenhos, marcas, código fonte do software, direitos
        sobre informações confidenciais ou segredos de negócio.
        <br />
        <br />
        Quaisquer marcas exibidas no aplicativo não devem ser consideradas como
        de domínio público e são de titularidade exclusiva da Sociedade, de seus
        parceiros
        <br />
        ou de terceiros licenciantes, conforme o caso.
        <br />
        A reprodução do conteúdo disponibilizado pelo Ooppah  sem a devida
        autorização, ou ainda sem a correspondente citação e referência ao Ooppah 
        constituirá infração aos direitos de propriedade intelectual da
        Sociedade, e sujeitará o Usuário às sanções administrativas, civis e
        criminais cabíveis.
        <br />
        <br />
        <b>7. DEVERES E LIMITAÇÕES DE USO</b>
        <br />
        <br />
        Ao se cadastrar no Ooppah , o Usuário declara e reconhece que:
        <br />
        <ul>
          <li data-list-text="*">
            Aceita receber informações, materiais e mensagens relacionadas ao
            Ooppah ;
          </li>
          <li data-list-text="*">
            Deverá realizar o pagamento do valor referente ao Plano de Acesso
            escolhido até as respectivas datas de vencimento, sob pena de
            suspensão de seu acesso a Serviços Premium cobrança do valor
            acrescido de multa e juros de mora;
          </li>
          <li data-list-text="*">
            Deverá cumprir com os termos e condições ora estabelecidos; e
          </li>
          <li data-list-text="*">
            Não está autorizado a republicar o conteúdo do aplicativo em nenhum
            outro meio, incluindo outros sites.
            <br />
            Uma vez constatado o uso fraudulento do Ooppah , a Sociedade promoverá
            a exclusão do Usuário do aplicativo, nada lhe sendo devido a que
            título for.
            <br />
            O Usuário declara, ainda, reconhecer que não poderá:
            <br />
          </li>
          <li data-list-text="*">
            Incluir informações falsas ou de propriedade de terceiros em seu
            cadastro;
          </li>
          <li data-list-text="*">
            Utilizar o Ooppah  para divulgar informações de qualquer forma que
            possa implicar em violação de normas aplicáveis no Brasil, de
            direitos de propriedade da Ooppah  e/ou de terceiros ou dos bons
            costumes, incluindo, sem limitação, a violação de direitos
            intelectuais, autorais e de privacidade, ou a produção e divulgação
            de conteúdo ilegal, imoral, inapropriado ou ofensivo;
          </li>
          <li data-list-text="*">
            Copiar, ceder, sublicenciar, vender, dar em locação ou em garantia,
            reproduzir, doar, alienar de qualquer forma, transferir total ou
            parcialmente, sob quaisquer modalidades, gratuita ou onerosamente,
            provisória ou permanentemente, o acesso ao Ooppah , assim como seus
            módulos, partes, manuais ou quaisquer informações relativas ao
            mesmo;
          </li>
          <li data-list-text="*">
            Empregar softwares, técnicas e/ou artifícios com o intuito de
            utilizar indevidamente o Ooppah  para práticas nocivas à Sociedade ou
            a terceiros, tais como a prática de fraudes, spamming, flooding e
            spoofing, etc;
          </li>
          <li data-list-text="*">
            Reproduzir, adaptar, modificar e/ou empregar, no todo ou em parte,
            para qualquer fim, o aplicativo sem a autorização expressa da
            Sociedade;
          </li>
          <li data-list-text="*">
            Publicar ou transmitir qualquer arquivo que contenha vírus,
            malwares, spywares ou qualquer outro programa contaminante ou
            destrutivo, ou que de outra forma possa interferir no bom
            funcionamento do Ooppah ; ou
          </li>
          <li data-list-text="*">
            Utilizar o aplicativo para finalidade diversa daquela para a qual
            foi disponibilizado pela Sociedade.
          </li>
        </ul>
        <b>8. RESPONSABILIDADE DAS PARTES</b>
        <br />
        <br />
        Adicionalmente às declarações prestadas e obrigações assumidas nestes
        Termos e Condições de Uso, o Usuário declara que está ciente de que o
        Ooppah , assim como qualquer outra plataforma de tecnologia, está
        suscetível a falhas, erros, problemas de acesso e similares, que fogem
        do controle da Sociedade.
        <br />
        <br />
        O Usuário assumirá toda a responsabilidade civil e criminal perante a
        Sociedade pelo descumprimento das obrigações previstas neste documento,
        pela inexatidão das suas declarações e por qualquer conduta ilícita,
        devendo indenizá-la, imediatamente, por quaisquer prejuízos e despesas,
        incluindo honorários de advogado e custas judiciais, incorridas pela
        Sociedade.
        <br />
        <br />
        A Sociedade não responderá, em nenhuma hipótese, ainda que em caráter
        solidário ou subsidiário:
        <br />
        <ul>
          <li data-list-text="*">
            Pela autenticidade, validade e precisão dos dados fornecidos pelo
            Usuário;
          </li>
          <li data-list-text="*">
            Por eventuais prejuízos sofridos pelo Usuário em razão da tomada de
            decisões com base nas informações disponibilizadas no Ooppah ;
          </li>
          <li data-list-text="*">
            Por situações de caso fortuito ou força maior, nos termos do artigo
            3U3 do Código Civil Brasileiro; e
          </li>
          <li data-list-text="*">
            Eventuais prejuízos sofridos pelo Usuário em razão de falhas no
            sistema de informática ou nos servidores que
          </li>
        </ul>
        independam de culpa da Sociedade ou em sua conectividade com a internet
        de modo geral, devendo o Usuário manter, às suas expensas, linha de
        telecomunicação, modem, software de comunicação, endereço de correio
        eletrônico e outros recursos necessários para a comunicação com a
        Sociedade.
        <br />
        <br />
        A Sociedade não garante que as funções contidas no Ooppah  atendam às suas
        necessidades, que sua operação será ininterrupta ou livre de erros ou
        que o aplicativo será compatível ou funcione com qualquer outro
        aplicativo, software ou serviços de terceiros.
        <br />
        <br />
        Em nenhum caso, a Sociedade será responsabilizada por danos pessoais ou
        qualquer prejuízo incidental, especial, indireto ou consequente, lucros
        cessantes, incluindo, sem limitação, prejuízos por perda de lucro,
        corrupção ou perda de dados, falha de transmissão ou recepção de dados,
        não continuidade do negócio ou qualquer outro prejuízo ou perda
        comercial, decorrentes ou relacionados ao uso de seu aplicativo, por
        qualquer outro motivo.
        <br />
        <br />
        O Usuário entende e concorda que a Sociedade irá adotar medidas de
        segurança e de proteção compatíveis com a natureza dos dados coletados,
        usados e armazenados pela Sociedade, no entanto, a Sociedade não garante
        de forma alguma que tais medidas de segurança sejam isentas de erros ou
        que não estejam sujeitas a interferência de terceiros (hackers, entre
        outros). Por sua natureza, apesar dos melhores esforços da Sociedade,
        qualquer medida de segurança pode falhar e qualquer dado do Usuário
        fornecido ou coletado pela Sociedade pode se tornar público. AO ACEITAR
        O TERMO DE USO E/OU USAR O Ooppah , O USUffiRIO ENTENDE E ASSUME
        EXPRESSAMENTE ESSE RISCO E CONCORDA QUE A SOCIEDADE NÃO SERA
        RESPONSAVEL POR TAL TIPO DE VAZAMENTO DE DADOS, DESDE QUE COMPROVADO
        QUE TODAS AS MEDIDAS DE SEGURANÇA FORAM ADOTADAS.
        <br />
        <br />
        Em um eventual caso de vazamento de dados, a Sociedade informará
        imediatamente o Usuário para que sejam tomadas as medidas necessárias de
        contenção de danos.
        <br />
        <br />
        <b>9. LEI E FORO APLICÁVEIS</b>
        <br />
        <br />
        Estes Termos e Condições de Uso serão interpretados exclusivamente
        segundo as leis do Brasil.
        <br />
        <br />
        As partes elegem o Foro da Comarca da Capital do Rio de Janeiro como o
        único competente para dirimir qualquer litígio resultante deste
        instrumento.
      </TermsText>
    </MainContainer>
  );
}
